import Vue from "vue";
import App from "./App.vue";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import ContentfulVue from "contentful-vue";

// Initialize Cloud Firestore and get a reference to the service

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(ContentfulVue, {
  space: "4pu2h4v5d6w7",
  accessToken: "MZL8bhU3n1cP36v3nHilfcb8nOwXGAElms9vqJNayzA",
  environment: "master"
});

new Vue({
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          secondary: "#00b4e2",
          primary: "#13286b"
        }
      }
    }
  }),
  render: (h) => h(App)
}).$mount("#app");
